import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-catogory-card',
  templateUrl: './order-catogory-card.component.html',
  styleUrls: ['./order-catogory-card.component.css']
})
export class OrderCatogoryCardComponent implements OnInit {
  @Input() title: string;
  @Input() icon: string;
  @Input() total: string | number = 0;
  constructor() { }

  ngOnInit(): void {
  }

}
